import jQuery from 'jquery';

import { isNonEmptyString } from 'Core/Utils/TypeUtils';

export function scrollToTop (target = 'html, body') {
  return scrollTo(target, 0);
};

export function scrollTo (target, scrollTop = 0, duration = 400) {
  return setTimeout(() => {
    jQuery(target).scroll();
    jQuery(target).animate({ scrollTop }, duration, 'swing');
  }, 250);
};

export function openUrl (url, external = null) {
  if (!isNonEmptyString(url))
    throw new TypeError(`openUrl: ${url} is not a string`);

  return external || (external === null && url.indexOf('https://') === 0 || url.indexOf('http://') === 0)
    ? window.open(url, '_blank')
    : window.location.href = url;
};

export function getOffset (target) {
  return jQuery(target).offset();
};



// WEBPACK FOOTER //
// ./client/Core/Utils/DomUtils.js